import dynamic from 'next/dynamic';

import type { CarbonScoreOverviewProps } from '@/domains/sustainability/carbonScore/components/CarbonScoreOverview/CarbonScoreOverview';
import { useCarbonScore } from '@/domains/sustainability/carbonScore/hooks/useCarbonScore';

const DynamicCarbonScoreOverview = dynamic<CarbonScoreOverviewProps>(() =>
  import(
    '@/domains/sustainability/carbonScore/components/CarbonScoreOverview/CarbonScoreOverview'
  ).then((mod) => mod.CarbonScoreOverview),
);

export const LazyCarbonScoreOverview = () => {
  const carbonScore = useCarbonScore();
  if (!carbonScore) return null;

  return (
    <DynamicCarbonScoreOverview productCarbonScore={carbonScore.product} />
  );
};
